<script>
  import { chainSymbol } from "../stores.js";

  import { isObject, getBalance } from "../utils.js";

  import Connect from "./connect.svelte";
  import ContractValue from "./contractValue.svelte";

  export let chain = undefined;
  export let address;
  export let contract = undefined;
  export let tokenId = undefined;
  export let formatted = true;
</script>

{#if $chainSymbol}
  <span class="lt-balance">
    {#await getBalance(chain, address, contract, tokenId, formatted)}
      <span class="loading"></span>
    {:then balance}
      {#if isObject(balance)}
        <span class="amount">{ new Intl.NumberFormat().format(balance.amount) }</span>
        <span class="symbol">{ balance.symbol }</span>
      {:else}
        <span class="amount">{ new Intl.NumberFormat().format(balance) }</span>
        {#if !contract}
          <span class="symbol">{ $chainSymbol }</span>
        {:else if !tokenId}
          <span class="symbol"><ContractValue { chain } { contract } member="symbol" /></span>
        {/if}
      {/if}
    <!-- {:catch error}
      <span class="error">{ JSON.stringify(error, null, ' ') }</span> -->
    {/await}
  </span>
{:else}
  <Connect />
{/if}